import { useState } from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import DefaultDatePicker from '../../../../common/datepicker/DefaultDatePicker'

const ContractInfo = ({ contractDetails, handleContractDetails, formErrors, isPersonal }) => {
	const { t } = useTranslation()
	const [selectedFee, setSelectedFee] = useState(contractDetails?.externalFee || null)

	return (
		<div className="p-3">
			{/* Contract Period */}
			<div className="">
				<h6 className="">{t('ContractPeriod', 'Sopimuskausi')}</h6>
				<Row className="">
					<Form.Group as={Col} lg={6} controlId="externalStartDate">
						<Form.Label>{t('ContractStartDateExternal', 'Sopimuksen alkamispäivä')}</Form.Label>
						<DefaultDatePicker
							id="externalStartDate"
							value={contractDetails?.externalStartDate || null}
							onChange={(date) => {
								handleContractDetails({
									target: {
										id: 'externalStartDate',
										value: date || '',
										type: 'date',
									},
								})
							}}
							disabled={isPersonal}
						/>
						{formErrors?.externalStartDate && (
							<Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
								{formErrors.externalStartDate}
							</Form.Control.Feedback>
						)}
					</Form.Group>

					<Form.Group as={Col} lg={6} controlId="externalEndDate">
						<Form.Label>{t('ContractEndDateExternal', 'Sopimuksen päättymispäivä')}</Form.Label>
						<DefaultDatePicker
							id="externalEndDate"
							value={contractDetails?.externalEndDate || null}
							onChange={(date) => {
								handleContractDetails({
									target: {
										id: 'externalEndDate',
										value: date || '',
										type: 'date',
									},
								})
							}}
							disabled={isPersonal}
						/>
						{formErrors?.externalEndDate && (
							<Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
								{formErrors.externalEndDate}
							</Form.Control.Feedback>
						)}
					</Form.Group>
				</Row>
			</div>

			<Row>
				<Form.Group className="mb-2" as={Col} xl={12} controlId="line1">
					<hr></hr>
				</Form.Group>
			</Row>

			{/* Contract Terms */}
			<div className="">
				<h6 className="">{t('ContractTerms', 'Sopimusehdot')}</h6>
				<Row className="">
					<Form.Group as={Col} lg={6} controlId="jobTitle">
						<Form.Label>{t('JobTitle', 'Tehtävänimike')}</Form.Label>
						<Form.Control
							type="text"
							defaultValue={contractDetails?.jobTitle || ''}
							onChange={handleContractDetails}
							disabled={isPersonal}
							isInvalid={!!formErrors?.jobTitle}
						/>
						{formErrors?.jobTitle && (
							<Form.Control.Feedback type="invalid">{formErrors.jobTitle}</Form.Control.Feedback>
						)}
					</Form.Group>
				</Row>

				<Row className="">
					<Form.Group as={Col} lg={6} controlId="cbaCode">
						<Form.Label>{t('ContractTypeExternal', 'Sopimussuhteen tyyppi')}</Form.Label>
						<Form.Control
							type="text"
							defaultValue={contractDetails?.cbaCode || ''}
							onChange={handleContractDetails}
							disabled={isPersonal}
							isInvalid={!!formErrors?.cbaCode}
						/>
						{formErrors?.cbaCode && <Form.Control.Feedback type="invalid">{formErrors.cbaCode}</Form.Control.Feedback>}
					</Form.Group>
				</Row>

				<Row className="">
					<Form.Group as={Col} controlId="assignment">
						<Form.Label>{t('JobDescription', 'Työtehtävät')}</Form.Label>
						<Form.Control
							type="text"
							defaultValue={contractDetails?.assignment || ''}
							onChange={handleContractDetails}
							disabled={isPersonal}
							isInvalid={!!formErrors?.assignment}
						/>
						{formErrors?.assignment && (
							<Form.Control.Feedback type="invalid">{formErrors.assignment}</Form.Control.Feedback>
						)}
					</Form.Group>
				</Row>

				<Row className="">
					<Form.Group as={Col} controlId="place">
						<Form.Label>{t('WorkLocation', 'Työntekopaikka/alue')}</Form.Label>
						<Form.Control
							type="text"
							defaultValue={contractDetails?.place || ''}
							onChange={handleContractDetails}
							disabled={isPersonal}
							isInvalid={!!formErrors?.place}
						/>
						{formErrors?.place && <Form.Control.Feedback type="invalid">{formErrors.place}</Form.Control.Feedback>}
					</Form.Group>
				</Row>

				<Row className="">
					<Form.Group as={Col} controlId="externalWorkHours">
						<Form.Label>{t('WorkingHours', 'Työaika')}</Form.Label>
						<Form.Control
							type="number"
							step="0.5"
							defaultValue={contractDetails?.externalWorkHours || ''}
							onChange={handleContractDetails}
							disabled={isPersonal}
							isInvalid={!!formErrors?.externalWorkHours}
						/>
						{formErrors?.externalWorkHours && (
							<Form.Control.Feedback type="invalid">{formErrors.externalWorkHours}</Form.Control.Feedback>
						)}
					</Form.Group>
				</Row>

				<Row className="">
					<Form.Group as={Col} controlId="externalWorkHoursInformation">
						<Form.Label>{t('WorkHoursInformation', 'Työajan lisätiedot')}</Form.Label>
						<Form.Control
							type="text"
							as="textarea"
							rows={3}
							defaultValue={contractDetails?.externalWorkHoursInformation || ''}
							onChange={handleContractDetails}
							disabled={isPersonal}
						/>
					</Form.Group>
				</Row>

				<Row className="">
					<Form.Group as={Col} controlId="termOfNotice">
						<Form.Label>{t('TerminationTerms', 'Irtisanomisehdot')}</Form.Label>
						<Form.Control
							type="text"
							defaultValue={contractDetails?.termOfNotice || ''}
							onChange={handleContractDetails}
							disabled={isPersonal}
							isInvalid={!!formErrors?.termOfNotice}
						/>
						{formErrors?.termOfNotice && (
							<Form.Control.Feedback type="invalid">{formErrors.termOfNotice}</Form.Control.Feedback>
						)}
					</Form.Group>
				</Row>
			</div>

			<Row>
				<Form.Group className="mb-2" as={Col} xl={12} controlId="line2">
					<hr></hr>
				</Form.Group>
			</Row>

			{/* Compensation */}
			<div className="">
				<h6 className="">{t('Compensation', 'Palkkio')}</h6>
				<Row className="">
					<Form.Group as={Col} controlId="externalFee">
						<Row>
							{[
								{
									value: 'FIXED',
									label: t('PredeterminedFixedPrice', 'Määritelty kiinteä hinta'),
								},
								{ value: 'HOURLY', label: t('HourlyRate', 'Tuntihinta') },
								{ value: 'DAILY', label: t('DailyRate', 'Päiväpalkkio') },
								{
									value: 'MONTHLY',
									label: t('MonthlyRate', 'Kuukausipalkkio'),
								},
								{ value: 'OTHER', label: t('Other', 'Muu') },
							].map((option) => (
								<Col key={option.value} xs={6} className="mb-1">
									<Form.Check
										type="radio"
										id={`externalFee-${option.value}`}
										name="externalFee"
										label={option.label}
										value={option.value}
										checked={selectedFee === option.value}
										onChange={(e) => {
											setSelectedFee(e.target.value)
											handleContractDetails({
												target: {
													id: 'externalFee',
													value: e.target.value,
													type: 'text',
												},
											})
										}}
										disabled={isPersonal}
									/>
								</Col>
							))}
						</Row>
						{formErrors?.externalFee && (
							<Form.Control.Feedback type="invalid" style={{ display: 'block' }}>
								{formErrors.externalFee}
							</Form.Control.Feedback>
						)}
					</Form.Group>
				</Row>
			</div>

			{/* Additional fee terms + Memo */}
			<div className="">
				<Row className="">
					<Form.Group as={Col} controlId="externalOtherFeeTerms">
						<Form.Label>{t('AdditionalCompensationDetails', 'Mahdolliset tarkennukset palkkioon')}</Form.Label>
						<Form.Control
							type="text"
							defaultValue={contractDetails?.externalOtherFeeTerms || ''}
							onChange={handleContractDetails}
							disabled={isPersonal}
							isInvalid={!!formErrors?.externalOtherFeeTerms}
						/>
						{formErrors?.externalOtherFeeTerms && (
							<Form.Control.Feedback type="invalid">{formErrors.externalOtherFeeTerms}</Form.Control.Feedback>
						)}
					</Form.Group>
				</Row>
				<Row>
					<Form.Group as={Col} controlId="externalMemo">
						<Form.Label>{t('Notes', 'Muistio')}</Form.Label>
						<Form.Control
							as="textarea"
							rows={3}
							defaultValue={contractDetails?.externalMemo || ''}
							onChange={handleContractDetails}
							disabled={isPersonal}
							isInvalid={!!formErrors?.externalMemo}
						/>
						{formErrors?.externalMemo && (
							<Form.Control.Feedback type="invalid">{formErrors.externalMemo}</Form.Control.Feedback>
						)}
					</Form.Group>
				</Row>
			</div>
		</div>
	)
}

export default ContractInfo
